import type { HttpPost } from '@/shared/infra/http'
import type { PostAnnouncement } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'
import { type AnnouncementDto, toAnnouncement } from './announcement-dto'

type PostAnnouncementResponseDto = {
  announcement: AnnouncementDto
}

export class EdgePostAnnouncementRepository {
  constructor(private readonly http: HttpPost) {}

  execute: PostAnnouncement = async (params) => {
    try {
      const data = await this.http.post<unknown, PostAnnouncementResponseDto>({
        url: '/connect/announcements',
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
          title: params.title,
          body: params.body,
        },
      })
      return { announcement: toAnnouncement(data.announcement) }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
